import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetRouteAccess } from '@/services/Users/GetRouteAccess';
import { RouteAccessDataInterface } from '../types/getRouteAccessInterface';

export const useRouteAccessStore = defineStore('routeAccess', () => {
  const routeAccess = ref<RouteAccessDataInterface>({
    isAuthenticated: false,
    isAllowedToAccess: false,
    redirectUrl: '',
    accessLevelStatus: '',
  });

  const getClient = () => {
    GetRouteAccess().then((response: RouteAccessDataInterface) => {
      routeAccess.value = response;
    });
  };

  return {
    routeAccess,
    getClient,
  };
});
